import { html, cssManager } from '@design.estate/dees-element';

export const demoFunc = () => {
  return html`
    <style>
      .ref1 {
        margin: 20px;
        width: 10px;
        height: 10px;
        background-color: red;
      }
    </style>
    <div class="ref1"></div>
    <dees-speechbubble .text=${`
      **This is a longer markdown text that  can be used the write**  
      a longer description about whats going on the app  
  
      **This is a subheader**
      and another text
    
    `}></dees-speechbubble>
  `;
};